import Link from 'next/link'
import React from 'react'
import PropTypes from 'prop-types'

const NextLink = (props) => {

    const {
        href,
        label,
        uppercase = true
    } = props

    return (
        <Link
            aria-label={label}
            href={href}
            target="_blank"
            className={`bg-[#EB532E] ${uppercase ? "uppercase" : ""}  relative text-white py-3.5 text-center text-nowrap px-8 rounded-full hover:underline transition-all duration-300 hover:bg-[#b33313] font-semibold`}
        >
            {label}
        </Link>
    )
}

NextLink.propTypes = {
    href: PropTypes.string,
    label: PropTypes.string,
}

export default NextLink